"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _colors = _interopRequireDefault(require("../theme/colors"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
/**
 * 
 * @param {*} props 
 */
var CheckboxStyled = function CheckboxStyled(props) {
  var style = {
    '&.MuiButtonBase-root:hover': {
      backgroundColor: _colors["default"].hoverGrey
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], (0, _extends2["default"])({
    sx: style
  }, props), props.children);
};
var _default = exports["default"] = CheckboxStyled;